"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuGroup = function MenuGroup(_ref) {
  var children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, ["children"]);

  return (0, _themeUi.jsx)("div", _extends({}, props, {
    sx: {
      width: '100%',
      alignItems: 'center',
      '&::after': {
        content: '""',
        height: '1px',
        bg: 'neutral.1',
        display: 'block',
        mx: 3,
        my: 2
      },
      '&:first-of-type': {
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      },
      '&:last-child': {
        borderBottomLeftRadius: 'inherit',
        borderBottomRightRadius: 'inherit',
        '&::after': {
          content: 'none'
        }
      }
    }
  }), children);
};

MenuGroup.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = MenuGroup;
exports["default"] = _default;